
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {addReport} from 'redux/modules/reports/actions'
import PromptContainer from 'components/PromptContainer'
import FormInput from 'components/FormInput'
import {Field, reduxForm, SubmissionError} from 'redux-form'
import {push as pushState} from 'react-router-redux'
import {batchActions} from 'redux-batch-enhancer'
import formatDate from 'date-fns/format'
import ButtonsGroup from 'components/ButtonsGroup'

export class ReportAddModal extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    today: PropTypes.object,
    initialize: PropTypes.func
  }

  static contextTypes = {
    timezone: PropTypes.string
  }

  componentDidMount() {
    const {timezone} = this.context
    const {initialize, today} = this.props

    initialize({
      timezone,
      name: `Report from ${formatDate(today, 'YYYY-MM-DD')}`
    })
  }

  render() {
    const {
      handleSubmit,
      invalid,
      submitting,
      closeModal
    } = this.props

    return (
      <PromptContainer className='report-add-view' title='Save report'>
        <form onSubmit={handleSubmit}>
          <Field
            name='name'
            label='Report name'
            disabled={submitting}
            autoFocus
            component={FormInput}
          />
          <Field
            name='timezone'
            type='hidden'
            component={FormInput}
          />
          <ButtonsGroup align='right'>
            <button type='button' onClick={closeModal}>Cancel</button>
            <button type='submit' disabled={submitting || invalid}>Create Report</button>
          </ButtonsGroup>
        </form>
      </PromptContainer>
    )
  }
}

const mapStateToProps = (state, {report, crossSiteMode}) => ({report, today: state.today})

export default connect(mapStateToProps, {
  closeModal
})(reduxForm({
  form: 'reportAdd',
  validate: ({name}) => {
    const errors = {}

    if (!name) {
      errors.name = 'Please provide report name'
    }

    return errors
  },
  onSubmit: ({name, timezone}, dispatch, {report, crossSiteMode}) => new Promise((resolve, reject) => {
    dispatch(addReport({name, timezone, ...report}, crossSiteMode))
      .success(response => {
        const {id} = response
        dispatch(batchActions([
          closeModal(),
          pushState(crossSiteMode ? `/cross-site/analytics/reports/${id}` : `/analytics/reports/${id}`)
        ]))

        resolve()
      })
      .fail(err => {
        reject(new SubmissionError({_error: err.message}))
      })
  })
})(ReportAddModal))



// WEBPACK FOOTER //
// ./client/modals/ReportAddModal/index.js